import _styled from "@emotion/styled-base";
import { css } from "@emotion/core";

var Arrow = /*#__PURE__*/_styled("div", {
  target: "ecs5mjg0"
})({
  name: "4vs9c2",
  styles: "width:0;height:0;border-width:6px;border-style:solid;content:\"\";position:absolute;"
}, function (_ref) {
  var placement = _ref.placement,
      color = _ref.color;
  if (!placement) return null;
  if (color == null) color = "white";

  if (placement.includes("top")) {
    return /*#__PURE__*/css("border-color:", color, " transparent transparent;top:100%;");
  }

  if (placement.includes("right")) {
    return /*#__PURE__*/css("border-color:transparent ", color, " transparent transparent;right:100%;");
  }

  if (placement.includes("bottom")) {
    return /*#__PURE__*/css("border-color:transparent transparent ", color, ";bottom:100%;");
  }

  if (placement.includes("left")) {
    return /*#__PURE__*/css("border-color:transparent transparent transparent ", color, ";left:100%;");
  }

  return null;
});

export default Arrow;